import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { newRow, getStatusStyles, duePaymentOptions } from "./constant";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { editCellContainerStyle } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { selectStyles } from "views/pages/manage/masters/holidayMaster/common";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import moment from "moment";
import { Tooltip } from "@mui/material";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import StatusCellComponent from '../../../../views/pages/manage/masters/studentFinancials/paymentCollectionSetup/securityDepositSequencing/StatusCellComponent.jsx';
import ActionsCellComponent from "./ActionsCellComponent";
import MultiSelectCellComponentWithSearch from "views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";
import AToggleButton from "../../../../components/AToggleButton";
import { ReactComponent as EyeIcon } from "assets/img/svg/eyeIcon.svg";


const ListComponent = forwardRef(
  (
    {
      currentPage = 0,
      currPageSize,
      rowCount,
      nextButtonHandler,
      dropdown,
      rows,
      createHandler,
      updateHandler,
      isNew,
      setIsNew,
      toggleStatusHandler,
      isBranchLevelConfig
    },
    ref
  ) => {
    const [rowModesModel, setRowModesModel] = useState({});

    const [rowData, setRowData] = useState(rows);
    const [rowForm, setRowForm] = useState({});

    useEffect(() => setRowData(rows), [rows]);

    const rowFormHandler = (value, key) =>
      setRowForm((prev) => ({ ...prev, [key]: value }));

    const startEditing = (id, form) => {
      setRowModesModel((oldModel) => ({ [id]: { mode: GridRowModes.Edit } }));
      setRowForm(form);
    };


    const stopEditing = () => {
      const currForm = { ...rowForm };
      setRowModesModel((oldModel) => ({
        [currForm?.id]: { mode: GridRowModes.View, ignoreModifications: true },
      }));
      setRowForm({});
    };

    const handleEditClick = (params) => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        startEditing(params?.id, params?.row);
      }
    };

    const handleCancelClick = async (params) => {
      if (params?.row?.isNew) {
        setRowData(rows);
        setRowForm({});
        setIsNew(false)
      } else {
        stopEditing(params?.id);
      }
    };

    const handleSaveClick = async (params) => {
      if (rowForm?.isNew) {
        await createHandler(rowForm);
        setIsNew(false)
      } else {
        await updateHandler(rowForm);
      }
    };
    const addNewRow = async () => {
      if (!isObjEmpty(rowForm)) {
        failureToast(saveOrDeleteMsg);
      } else {
        setIsNew(true)
        let randomId = generateRandomId();
        let emptyRow = { ...newRow, isNew: true, id: randomId };
        startEditing(randomId, emptyRow);
        setRowData((prev) => [emptyRow, ...prev]);
      }
    };

    useImperativeHandle(ref, () => ({
      addNewRow: addNewRow,
      startEditing: startEditing,
      stopEditing: stopEditing,
    }));

    const columns = [
      new AGridColDef("businessGroup", "Business Group", false)
        .setMinWidth(130)
        .editable(isNew)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessGroup}
              handleChange={(value) => rowFormHandler(value, "businessGroup")}
              items={dropdown?.businessGroup}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),

      new AGridColDef("companyCode", "Company Code", false)
        .setMinWidth(130)
        .editable(isNew)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.companyCode}
              handleChange={(value) => rowFormHandler(value, "companyCode")}
              items={dropdown?.companyCode}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      ...(isBranchLevelConfig ? [new AGridColDef("businessArea", "Business Area", false)
        .setMinWidth(130)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div>
            <span>{params.value?.label}</span>&nbsp;
            <Tooltip title={params?.value?.businessAreaDesc}>
              <span>
                <EyeIcon />
              </span>
            </Tooltip>
          </div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.businessArea}
              handleChange={(value) => rowFormHandler(value, "businessArea")}
              items={dropdown?.businessArea}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>)
        )] : []),
      new AGridColDef("academicCareer", "Academic Career", true)
        .setMinWidth(130)
        .editable(isNew)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.academicCareer}
              handleChange={(value) => rowFormHandler(value, "academicCareer")}
              items={dropdown?.academicCareer}
              isMulti={false}
              style={selectStyles}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("minimumItemType", "Min Item Type", true)
        .setMinWidth(155)
        .editable(true)
        .setFlex(0.7)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value?.label}>
            <div className={`ellipsis-text-container`}>{params?.value?.label}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.minimumItemType}
              handleChange={(value) => rowFormHandler(value, "minimumItemType")}
              items={dropdown?.minimumItemType}
              isMulti={false}
              style={{ control: { ...selectStyles.control, width: '140px' } }}
              autoFocus={params?.hasFocus}
            />
          </div>
        )),
      new AGridColDef("programActions", "Program Action", false)
        .setMinWidth(160)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          <MultiSelectCellComponentWithSearch
            title={"Program Action"}
            data={params?.value}
            eyeIcon
          />
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              currentValue={rowForm?.programActions}
              handleChange={(value) => rowFormHandler(value, "programActions")}
              items={dropdown?.programActions}
              isMulti={true}
              style={{ control: { ...selectStyles.control, width: '140px' } }}
              autoFocus={params?.hasFocus}
              selectAllMenuButton={true}
              isShowCount={true}
            />
          </div>
        )),
      new AGridColDef("afterStartDate", <div className="d-flex align-items-center ">
        After Start Date
        <Tooltip title="Number of days after the course start date used to determine student transfer eligibility. Should be less than 9999">
          <span className="d-flex align-items-center">
            <IoMdInformationCircleOutline
              className="ml-2 pointer"
              size={18}
            />
          </span>
        </Tooltip>
      </div>, false)
        .setMinWidth(170)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          <div>
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder='Enter'
              value={rowForm?.afterStartDate}
              handler={(value) => {
                if (value === "" || value === null) {
                  rowFormHandler("", "afterStartDate");
                } else if (value >= 0 && value <= 9999) {
                  rowFormHandler(value, "afterStartDate");
                }
              }}
              regex={regex?.numeric}
            />
          </div>
        )),
      new AGridColDef("beforeStartDate", <div className="d-flex align-items-center ">
        Before Start Date
        <Tooltip title="Number of days before the course start date used to determine student transfer eligibility. Should be less than 9999.">
          <span className="d-flex align-items-center">
            <IoMdInformationCircleOutline
              className="ml-2 pointer"
              size={18}
            />
          </span>
        </Tooltip>
      </div>, false)
        .setMinWidth(170)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          <div>
            <Tooltip title={params?.value}>
              <div className={`ellipsis-text-container`}>{params?.value}</div>
            </Tooltip>
          </div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder='Enter'
              value={rowForm?.beforeStartDate}
              handler={(value) => {
                if (value === "" || value === null) {
                  rowFormHandler("", "beforeStartDate");
                } else if (value >= 0 && value <= 9999) {
                  rowFormHandler(value, "beforeStartDate");
                }
              }}
              regex={regex?.numeric}
            />
          </div>
        )),
      new AGridColDef("transferLimit",
        <div className="d-flex align-items-center ">
          Transfer Limit
          <Tooltip title="Number of transfers made by the student prior to becoming eligible for transfer">
            <span className="d-flex align-items-center">
              <IoMdInformationCircleOutline
                className="ml-2 pointer"
                size={18}
              />
            </span>
          </Tooltip>
        </div>
        , false)
        .setMinWidth(160)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AInput
              placeholder='Enter'
              value={rowForm?.transferLimit}
              handler={(value) => rowFormHandler(value, "transferLimit")}
              regex={regex?.numeric}
            />
          </div>
        )),
      new AGridColDef("duePayment", <div className="d-flex align-items-center ">
        Due Payment
        <Tooltip title="Outstanding amount should be paid to becoming eligible for transfer">
          <span className="d-flex align-items-center">
            <IoMdInformationCircleOutline
              className="ml-2 pointer"
              size={18}
            />
          </span>
        </Tooltip>
      </div>, false)
        .setMinWidth(148)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          <AToggleButton
            toggleOptions={duePaymentOptions}
            value={params?.value} />
        ))
        .renderEditCellComponent((params) => (
          <div style={editCellContainerStyle}>
            <AToggleButton
              toggleOptions={duePaymentOptions}
              value={rowForm?.duePayment}
              handleChange={val => rowFormHandler(val, "duePayment")}
            />
          </div>
        )),
      new AGridColDef("createdBy", "Created By", false)
        .setMinWidth(120)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={params?.value}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
      ,

      new AGridColDef("createdOn", "Created on", false)
        .setMinWidth(130)
        .setFlex(1)
        .renderCellComponent((params) =>
          params?.value ? (
            <div>
              {moment(params?.value)?.format("DD-MMM-YYYY")}
              <Tooltip
                title={`${getFormattedDate(params?.value)},
                    ${moment(params?.value).format("LT")}`}
              >
                <span>
                  <IoMdInformationCircleOutline
                    className="ml-2 pointer"
                    size={18}
                  />
                </span>
              </Tooltip>
            </div>
          ) : (
            <div>-</div>
          )
        ),
      new AGridColDef("updatedBy", "Updated By", false)
        .setMinWidth(120)
        .editable(true)
        .setFlex(1)
        .renderCellComponent((params) => (
          params?.value ? <div><Tooltip title={`${moment(params?.row?.updatedOn).format('DD-MMM-YY')} by ${params.value}`}>
            <div className={`ellipsis-text-container`}>{params?.value}</div>
          </Tooltip></div> : <div>-</div>
        ))
      ,
      new AGridColDef("status", "Status", false)
        .setMinWidth(100)
        .setFlex(1)
        .editable(true)
        .renderCellComponent((params) => (
          <CustomChip
            text={params?.value}
            textColor={getStatusStyles(params?.value)?.textColor}
            bgColor={getStatusStyles(params?.value)?.bgColor}
          />
        ))
        .renderEditCellComponent((params) => (<StatusCellComponent
          params={params}
          toggleStatusHandler={toggleStatusHandler}
          rowForm={rowForm}
          rowFormHandler={rowFormHandler}
        />
        ))
      ,
      new AGridColDef("actions", "Actions", false)
        .setMinWidth(130)
        .columnAlign("right")
        .setFlex(1)
        .renderCellComponent((params) => (
          <>
            <ActionsCellComponent
              params={params}
              handleEditClick={handleEditClick}
              handleCancelClick={handleCancelClick}
              handleSaveClick={handleSaveClick}
              rowForm={rowForm}
            />
          </>
        )
        ),
    ];
    return (
      <div className="mt-3">
        <ADataGrid
          removeWrapperContainer
          rowModesModel={rowModesModel}
          rows={rowData || []}
          columns={columns}
          rowId={(row) => row?.id}
          rowHeight={50}
          rowCount={rowCount}
          loading={false}
          currentPage={currentPage}
          nextButtonHandler={nextButtonHandler}
          sx={{
            ...gridStyles,
          }}
          autoHeight
          paginationModel={{ page: currentPage, pageSize: currPageSize }}
        />
      </div>
    );
  }
);
export default ListComponent;
